var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.87 101.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e5e5e5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.63,83.51a173.82,173.82,0,0,1-19.3-13.7l.6-.88S77.58,54.6,78.18,51.44s-4.37-3.62-5-2.41S63,64.86,63,64.86l-.62.74c-6-5.28-10.4-10.59-15.84-17.66l1.64-1.74S71.55,25.32,56.92,7.53s-40.4,0-39.8,11.91A69.27,69.27,0,0,0,24,45.12l-.73.7S-3.83,66.17.84,83.81s27.79,24.21,49,10.11a43.81,43.81,0,0,0,9-9.51l.72-1.17A139.68,139.68,0,0,0,82.1,94.52,10.37,10.37,0,0,0,86.63,83.51ZM43.05,13c12.67.91,9.05,11,5.88,15.38a42.83,42.83,0,0,1-8.44,8.14l-1.09.84a63.34,63.34,0,0,1-5.69-13.2S30.39,12.05,43.05,13Zm9.88,68S41,96.46,27.68,89.54C8.56,79.6,30.39,57.73,30.39,57.73L31,57A98.25,98.25,0,0,0,53.81,79.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.76,61.92s-12.64,36,30.08,37.77c0,0-22.34,7.65-32.85-6.58C-7.67,76,7.76,61.92,7.76,61.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.89,90.26s-39-16.54-55.5-49.55c-13.52-27,.29-38,.29-38C15.2,9.56,16.75,21.85,16.75,21.85,25.35,77.77,82.07,94.6,82.07,94.6A12.65,12.65,0,0,0,85.89,90.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndWhiteIcon);
export default __webpack_public_path__ + "static/media/and-white-icon.f526f7d5814714dc3ae59864f97dd089.svg";
export { ForwardRef as ReactComponent };